/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  ExpressionCorrectionRequest,
  ExpressionHistory,
  PatientCommonExpression,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    ExpressionCorrectionRequestFromJSON,
    ExpressionCorrectionRequestToJSON,
    ExpressionHistoryFromJSON,
    ExpressionHistoryToJSON,
    PatientCommonExpressionFromJSON,
    PatientCommonExpressionToJSON,
} from '../models/index';

export interface CorrectExpressionRequest {
    id: number;
    expressionCorrectionRequest: ExpressionCorrectionRequest;
}

export interface GetExpressionHistoryRequest {
    id: number;
}

/**
 * 
 */
export class ExpressionsApi extends runtime.BaseAPI {

    /**
     * Updates the value of an expression and automatically stores the correction in the expression history. 
     * Correct an expression
     */
    async correctExpressionRaw(requestParameters: CorrectExpressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientCommonExpression>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling correctExpression().'
            );
        }

        if (requestParameters['expressionCorrectionRequest'] == null) {
            throw new runtime.RequiredError(
                'expressionCorrectionRequest',
                'Required parameter "expressionCorrectionRequest" was null or undefined when calling correctExpression().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/expressions/{id}/correction`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ExpressionCorrectionRequestToJSON(requestParameters['expressionCorrectionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientCommonExpressionFromJSON(jsonValue));
    }

    /**
     * Updates the value of an expression and automatically stores the correction in the expression history. 
     * Correct an expression
     */
    async correctExpression(requestParameters: CorrectExpressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientCommonExpression> {
        const response = await this.correctExpressionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the list of corrections applied to an expression, ordered by correction date in descending order. 
     * Get expression correction history
     */
    async getExpressionHistoryRaw(requestParameters: GetExpressionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExpressionHistory>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getExpressionHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/expressions/{id}/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExpressionHistoryFromJSON));
    }

    /**
     * Returns the list of corrections applied to an expression, ordered by correction date in descending order. 
     * Get expression correction history
     */
    async getExpressionHistory(requestParameters: GetExpressionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExpressionHistory>> {
        const response = await this.getExpressionHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
